import { configurationForToken } from "../CommonConstants";
import apiClient from "./apiClient";

const addUser = (user, token) => {
  const config = configurationForToken(token);
  const {email,name, password } = user
  return apiClient.post("/user/create", {
    id: user.id,
    email,
    password,
    name,
    type: user.type || null,
    companyId: user.companyName || null
  }, config);
};

const updateUser = (user, token) => {
  const config = configurationForToken(token);
  return apiClient.put("/user/edit", {
    id: user.id,
    email: user.email,
    name: user.name,
    type: user.type || null,
    companyId: user.companyName || null
  }, config);
};

const disableUser = (userId, token) => {
  const config = configurationForToken(token);
  return apiClient.delete("/user/disable", { data: {id: userId}, ...config });
};

const enableUser = (userId, token) => {
  const config = configurationForToken(token);
  return apiClient.put("/user/enable", {id: userId} ,config );
};

const allUsers = (token) => {
  const config = configurationForToken(token);
  return apiClient.get("/user/all", config);
};

export default {
  addUser,
  updateUser,
  disableUser,
  allUsers,
  enableUser
};



// WEBPACK FOOTER //
// ./src/Services/UserService.js